import AuthGuard from '@components/AuthGuard';
import Button from '@components/Button';
import colors from '@constants/colors';
import useUser from '@hooks/auth/useUser';
import { EventResponse } from '@models/event';
import { useTranslation } from 'react-i18next';

import useAttendanceCheck from '../../hooks/useAttendanceCheck';
import useAttendanceEvent from '../../hooks/useAttendanceEvent';

interface Props {
    eventId: string
}

function EventFooter({ eventId }:Props) {
    const { t } = useTranslation('event');
    const { policy } = useAttendanceEvent(eventId);
    const handleCheckIn = useAttendanceCheck(eventId, 'APP_BUTTON');

    if (policy?.checkInType === 'APP_BUTTON') {
        return (
            <AuthGuard flows={[
                { activityName: 'BoardActivity', activityParams: { type: 'EVENT' } },
                { activityName: 'EventActivity', activityParams: { eventId } },
            ]}>
                <Button fullWidth
                    color={policy?.buttonTextColor === 'WHITE' ? 'white' : colors.gray6}
                    backgroundColor={policy?.buttonBackgroundColor}
                    onClick={handleCheckIn} >
                    {t('attendance.checkIn')}
                </Button>
            </AuthGuard>
        );
    }
    return null;
}

export default EventFooter;
